import { parseThirdPartyARI } from '@atlassian/search-client/ari';

import { is3pProductKey } from '../constants/products';

export const getProductFromThirdPartyId: ({
	thirdPartyId,
}: {
	thirdPartyId?: string;
}) => import('@atlassian/rovo-connectors-config/types').ProductKeys3P | undefined = ({
	thirdPartyId,
}: {
	thirdPartyId?: string;
}) => {
	try {
		if (thirdPartyId) {
			const { resourceOwner } = parseThirdPartyARI(thirdPartyId);
			const resourceType = resourceOwner.split('.')[1];
			const productKey =
				resourceType === 'google-drive' || resourceType === 'google-drive-lite'
					? 'drive'
					: resourceType || '';
			if (is3pProductKey(productKey)) {
				return productKey;
			}
		}
		return undefined;
	} catch (e) {
		// If parsing fails, we default to undefined
		return undefined;
	}
};
